import React from "react";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { Button, List, Popconfirm } from "antd";

const AddressBookItem = ({
  item,
  onClickEdit,
  onClickUse,
  onClickDelete,
  addressDeleteIds,
  isDeletingAddress,
  handleDeleteAddress,
  handleCancelDeleteAddress,
}) => {
  /**
   * @type {Address}
   */
  const addressData = item;

  const { id, name, addressLine1, addressLine2, city, stateShortName: state, zipCode } = addressData;

  return (
    <List.Item
      actions={[
        <Button key="edit-address" size="small" icon={<EditOutlined />} shape="circle" onClick={onClickEdit} />,
        <Popconfirm
          visible={addressDeleteIds.includes(id)}
          key="delete-address"
          title={isDeletingAddress ? "Deleting..." : "Are you sure?"}
          onConfirm={handleDeleteAddress}
          onCancel={handleCancelDeleteAddress}
          okText="Yes"
          okButtonProps={{ loading: isDeletingAddress }}
          cancelButtonProps={{ disabled: isDeletingAddress }}
        >
          <Button size="small" type="danger" icon={<DeleteOutlined />} shape="circle" onClick={onClickDelete} />
        </Popconfirm>,
        <Button key="use-address" size="small" type="primary" onClick={onClickUse}>
          Use
        </Button>,
      ]}
    >
      <List.Item.Meta title={name} description={`${addressLine1} ${city} ${state} ${zipCode}`} />
    </List.Item>
  );
};

export default AddressBookItem;
